var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 15.5 19.5", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.75 0.75V18.75M8.75 4.75H10.75M8.75 8.75H10.75M1.75 0.75H12.75C13.2804 0.75 13.7891 0.960714 14.1642 1.33579C14.5393 1.71086 14.75 2.21957 14.75 2.75V14.75C14.75 15.2804 14.5393 15.7891 14.1642 16.1642C13.7891 16.5393 13.2804 16.75 12.75 16.75H1.75C1.48478 16.75 1.23043 16.6446 1.04289 16.4571C0.855357 16.2696 0.75 16.0152 0.75 15.75V1.75C0.75 1.48478 0.855357 1.23043 1.04289 1.04289C1.23043 0.855357 1.48478 0.75 1.75 0.75Z", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});